import HomeLogo from "@/assets/loginLogo.svg";
import UserPanel from "@/Components/PageTop/UserPanel";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import QueryBar from '@/Components/QueryBar'

const Component = () => {
  const history = useNavigate();

  return (
    <div className="homeSearch">
      <div className="pTop">
        <div></div>
        <UserPanel />
      </div>
      <div className="inputSearch">
        <div className="searchContent">
          <div>
            <img src={HomeLogo} alt="" />
          </div>
          <QueryBar type='index'/>
          <Button onClick={() => history("/mixture")} className="mt2" type="primary">
            混合物物性计算
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Component;
